const MenuItems = [
    {
        title: 'Explore',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Creators',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Community',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Connect Wallet',
        url: '#',
        cName: 'nav-links-btn'
    }
]

export default MenuItems;